import { Box, Button, Grid, VStack, chakra, Skeleton, Text, HStack } from '@chakra-ui/react';

import Clinico from '../../../../../../images/dashboard/clinico.svg';
import Pediatra from '../../../../../../images/dashboard/pediatra.svg';
import Veterinario from '../../../../../../images/dashboard/veterinario.svg';
import useModelCardsTelemedicina from './useModelCardsTelemedicina';

import React, { useState } from 'react';

function CardsTelemedicina({ prontoAtendimento, error, loading, gratuito }) {
  const { navigate, assinante, logado, setUser } = useModelCardsTelemedicina();
  const [imgLoaded, setImgLoaded] = useState({ clinico: false, pediatra: false, veterinario: false });
  return (
    <>
      <Grid
        templateColumns={{ base: '1fr 1fr 1fr', sm: 'repeat(3, 1fr)' }}
        gap={4}
        width="100%"
        maxWidth="900px"
        mx="auto"
        py={2}
        px={{ base: 3, md: 6 }}
      >
        <Button
          bg="white"
          color="#616161"
          p={6}
          borderRadius="1em"
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          _focus={false}
          onClick={() => {
            if (error || prontoAtendimento?.valor_clinico === undefined || prontoAtendimento?.valor_clinico === null) {
              return;
            }

            if (gratuito) {
              setUser((prevUser) => ({
                ...prevUser,
                paga_telemedicina: false,
              }));
              navigate('/aviso-pre-atendimento/', {
                state: { titulo: 'Pronto Atendimento', tela: '/medico-agora/', pediatra: false },
              });
              return;
            }

            navigate('/pagamento-telemedicina', {
              state: { tipoAtendimento: 'clinico', telemedicina: true },
            });
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Box position="relative" width="fit-content" mx="auto" height="56px">
              <chakra.h1
                bg="#2A918A"
                color={'white'}
                borderRadius="full"
                px={{ base: 2, md: 3 }}
                py={{ base: 1, md: 2 }}
                fontSize={{ base: 'xs', md: 'sm' }}
                minW={{ base: '32px', md: '48px' }}
                textAlign="center"
                position="absolute"
                left={{ base: '-18px', md: '-18px' }}
                top={{ base: '-18px', md: '-16px' }}
                boxShadow="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                24h
              </chakra.h1>
              <Skeleton isLoaded={imgLoaded.clinico} borderRadius="full" width="50px" height="50px">
                <img
                  src={Clinico}
                  alt="Clínico Geral 24h"
                  style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, clinico: true }))}
                />
              </Skeleton>
            </Box>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Clínico Geral
            </chakra.span>
            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_clinico !== undefined && prontoAtendimento?.valor_clinico !== null
                    ? Number(prontoAtendimento.valor_clinico).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>

        <Button
          bg="white"
          color="#616161"
          p={6}
          borderRadius="1em"
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          _focus={false}
          onClick={() => {
            if (error || prontoAtendimento?.valor_pediatra === undefined || prontoAtendimento?.valor_pediatra === null) {
              return;
            }
            if (gratuito) {
              setUser((prevUser) => ({
                ...prevUser,
                paga_telemedicina: false,
              }));
              navigate('/aviso-pre-atendimento/', {
                state: {
                  titulo: 'Pronto Atendimento Pediátrico',
                  tela: '/medico-agora/',
                  pediatra: true,
                },
              });
              return;
            }

            navigate('/pagamento-telemedicina', {
              state: { tipoAtendimento: 'pediatra', telemedicina: true },
            });
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Box position="relative" width="fit-content" mx="auto" height="56px">
              <chakra.h1
                bg="#2A918A"
                color={'white'}
                borderRadius="full"
                px={{ base: 2, md: 3 }}
                py={{ base: 1, md: 2 }}
                fontSize={{ base: 'xs', md: 'sm' }}
                minW={{ base: '32px', md: '48px' }}
                textAlign="center"
                position="absolute"
                left={{ base: '-18px', md: '-18px' }}
                top={{ base: '-18px', md: '-16px' }}
                boxShadow="md"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                24h
              </chakra.h1>
              <Skeleton isLoaded={imgLoaded.pediatra} borderRadius="full" width="50px" height="50px">
                <img
                  src={Pediatra}
                  alt="Pediatria 24h"
                  style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                  onLoad={() => setImgLoaded((prev) => ({ ...prev, pediatra: true }))}
                />
              </Skeleton>
            </Box>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Pediatria
            </chakra.span>

            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_pediatra !== undefined && prontoAtendimento?.valor_pediatra !== null
                    ? Number(prontoAtendimento.valor_pediatra).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>

        <Button
          bg="white"
          color="#616161"
          p={6}
          minW={0}
          h={{ base: '120px', md: '140px', lg: '150px' }}
          boxShadow="lg"
          borderRadius="1em"
          _focus={false}
          onClick={() => {
            if (error || prontoAtendimento?.valor_veterinario === undefined || prontoAtendimento?.valor_veterinario === null) {
              return;
            }
            if (gratuito) {
              setUser((prevUser) => ({
                ...prevUser,
                paga_telemedicina: false,
              }));
              navigate('/aviso-pre-atendimento/', {
                state: { titulo: 'Telemedicina Pet', tela: '/telepet/termos/', pediatra: false },
              });
              return;
            }
            navigate('/pagamento-telemedicina', {
              state: { tipoAtendimento: 'veterinario', telemedicina: true },
            });
          }}
        >
          <VStack spacing={1} align="center" width="100%">
            <Skeleton isLoaded={imgLoaded.veterinario} borderRadius="full" width="50px" height="50px">
              <img
                src={Veterinario}
                alt="Veterinário"
                style={{ width: '50px', height: '50px', position: 'relative', borderRadius: '50%' }}
                onLoad={() => setImgLoaded((prev) => ({ ...prev, veterinario: true }))}
              />
            </Skeleton>
            <chakra.span fontWeight="semibold" fontSize="sm">
              Veterinário
            </chakra.span>
            <Skeleton isLoaded={!loading} width="60px" height="20px" borderRadius="md">
              <HStack justifyContent="center">
                <chakra.span fontSize="xs" color={!error || (!error && !prontoAtendimento?.faltou) ? '#616161' : 'red.600'}>
                  R${' '}
                  {!error && prontoAtendimento?.valor_veterinario !== undefined && prontoAtendimento?.valor_veterinario !== null
                    ? Number(prontoAtendimento.valor_veterinario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                    : '!'}
                </chakra.span>
              </HStack>
            </Skeleton>
          </VStack>
        </Button>
      </Grid>
      {assinante && prontoAtendimento?.faltou && (
        <>
          <Box
            align="left"
            borderRadius="0.8em"
            p={4}
            shadow="sm"
            w="100%"
            border="1px solid #FFCBCF"
            bg="linear-gradient(90deg, #FFEAED 0%, #FFEAED 100%)"
            o
            style={{
              boxShadow: '0 0 5px rgba(255, 203, 207, 0.5)',
            }}
          >
            <VStack align="center" spacing={0}>
              <Text fontWeight="bold" fontSize="1.2em" color="#D62422">
                Importante!
              </Text>
              <Text color="#D62422" fontSize="sm" mt={1}>
                O valor cobrado refere-se a uma multa de 50% do valor da consulta, aplicada por faltas em atendimentos anteriores no período de 60
                dias.
              </Text>
            </VStack>
          </Box>
        </>
      )}
    </>
  );
}

export default CardsTelemedicina;
